export const ENV: string | undefined = process.env.REACT_APP_ENV;
export const LOG_LEVEL: string | undefined = process.env.REACT_APP_LOG_LEVEL;
export const IMAGES_URL: string | undefined = process.env.REACT_APP_IMAGES_URL;
export const DOCUMENTS_URL: string | undefined = process.env.REACT_APP_DOCUMENTS_URL;
export const SERVER: string | undefined = process.env.REACT_APP_BE_SERVER;
export const WEBSOCKET: string | undefined = process.env.REACT_APP_BE_WEBSOCKET;
export const HOST: string | undefined = process.env.REACT_APP_HOST;
export const WHATSAPP_URL: string | undefined = process.env.REACT_APP_WHATSAPP_URL;
export const TELEGRAM_URL: string | undefined = process.env.REACT_APP_TELEGRAM_URL;

export const ENV_DEV: string = 'dev';
export const ENV_TEST: string = 'test';
export const ENV_PROD: string = 'prod';
